import React from 'react';
import {Navigate} from 'react-router';
import {useSelector} from 'react-redux';

function RouteForL1({children}) {
  const {userInfo} = useSelector (state => state.auth);
  const {role} = userInfo;
  return role?.categories?.includes("L1") ? children : <Navigate to="/" />;
}

export default RouteForL1;
